export function dotty (str, len) {
  if (typeof str !== 'string') return str
  if (str.length < len) return str
  return str.substring(0, len) + '...'
}



// WEBPACK FOOTER //
// ./src/Services/stringLengthPadding.js